module.exports = __webpack_public_path__ + "assets/pretiis.356f0dc4.svg";